import { Control } from 'superlikers-dynamic-forms'

export const loginControls: Control[] = [
  {
    label: 'Número de Cliente',
    name: 'codigo-de-cliente',
    controlType: 'input',
    type: 'text',
    validators: {
      required: true
    }
  },
  {
    label: 'Contraseña',
    name: 'password',
    controlType: 'input',
    type: 'password',
    validators: {
      required: true
    }
  }
]
